export default __webpack_public_path__ + "img/program2.371a425f.svg";